import client from './client';
import loadScript from './load-script';
import { parseQuery } from './common';
export default { client: client, loadScript: loadScript, parseQuery: parseQuery };
//# sourceMappingURL=index.js.map